import DollarSign from "../../icons/DollarSign";
import GatewayJobsIcon from "../../icons/GatewayJobs";

interface JobLevelOptionsProps {
  filter: string
}
const TagsInfo: any = {
  'Gateway Jobs':
    '<span style="font-weight: bold">Short-term training or experience required.</span> Find in-demand jobs that offer benefits, living wage pay and open the door to career advancement. These jobs are also associated to the <span style="font-style: italic">low cost, short-term credentialing</span> in our SkillUp Training Catalog. ',

  'Earn & Learn':
    '<span style="font-weight: bold">No training or experience required.</span> Find entry-level positions that offer benefits, living wage pay, and on-the-job training or tuition reimbursement. ',

};
const JobLevelOptions: React.FC<JobLevelOptionsProps> = ({ filter }) => {
  return <div>
    <div className="flex items-center">
      {filter == 'Gateway Jobs' ?

        <GatewayJobsIcon
          className={'w-5 h-5 fill-checkbox mt-0.5 mr-1 p-0.5'}

        /> : <DollarSign
          className={'w-5 h-5 fill-checkbox mt-0.5 mr-1 p-0.5'}

        />}

      <h1 className="ml-1 text-base font-bold text-left text-gray1 font-base">
        {filter}
      </h1>
    </div>
    <p dangerouslySetInnerHTML={{ __html: TagsInfo[filter] }} className="my-2 text-sm text-left text-gray1 font-base">

    </p>
  </div>;
};

export default JobLevelOptions;